import {concatXpath, getBlockElem, getElemsByXPath, hasElementsByXPathList, isParentForElem} from "../../utils/utils";
import {getXPathForField} from "../../utils/xpath_minimizer";
import {Field, Fields} from "../fields";
import {Segment} from "../segment";

function extendField(newModel: Fields, field: Field, segmentElem: HTMLElement): Field {
    const blocksContainerElem = segmentElem.parentElement!;

    const newXPathList = new Set<string>();
    for (const xpath of field.xpath_list) {
        const elems = getElemsByXPath(field.model.document, field.model.document.getRootNode() as HTMLElement, xpath);

        if (elems.length > 0) {
            const blockElem = getBlockElem(elems[0], blocksContainerElem);
            newXPathList.add(getXPathForField(elems[0], false, false, blockElem!, field.type));
        }
    }

    return new Field(newModel, field.name, field.type, newXPathList)
}

function extendModel(model: Fields, segmentElem: HTMLElement): Fields | null {
    // 1. Проверяем, что все элементы модели находятся внутри сегмента. Если это не так, обощение не возможно.
    // 2. Переводим все поля в относительные XPATH-ы
    // 3. Проверяем обощение: все подобные сегменту блоки должны содержать как минимум по одному элементу от каждого
    //    поля
    const parent = segmentElem.parentElement;
    if (!parent) {
        return null;
    }

    const blocks = getElemsByXPath(segmentElem.ownerDocument, parent, `./${segmentElem.tagName}`);

    const blocksContainerElem = segmentElem.parentElement!;
    const blockXPath = concatXpath(getXPathForField(blocksContainerElem, true, false, null, null), segmentElem.tagName.toLowerCase());

    const newModel = new Fields(model.document, blockXPath);
    for (const field of model.fields.values()) {
        const elems = field.getElements();
        for (const elem of elems) {
            if (!isParentForElem(elem, segmentElem)) {
                return null;
            }
        }

        const extendedField = extendField(newModel, field, segmentElem)

        if (extendedField.xpath_list.size > 0) {
            let founded = 0;
            for (const block of blocks) {
                if (extendedField.xpath_list.size > 0 && !hasElementsByXPathList(block as HTMLElement, Array.from(extendedField.xpath_list))) {
                    continue
                }

                founded += 1
            }

            if (founded < 2) {
                return null;
            }
        }
        newModel.fields.set(extendedField.name, extendedField)
    }

    return newModel
}

function unextendField(newModel: Fields, field: Field, segment: HTMLElement): Field {
    const document = field.model.document

    const newXPathList = new Set<string>();
    for (const xpath of field.xpath_list) {
        const elems = getElemsByXPath(document, segment, xpath);
        for (const elem of elems) {
            if (isParentForElem(elem, segment)) {
                newXPathList.add(getXPathForField(elem, false, false, document.getRootNode() as HTMLElement, field.type))
            }
        }
    }

    return new Field(newModel, field.name, field.type, newXPathList);
}

// Конвретирует все xpath всех полей из относительных в абсолютные, элемент `segment` - элемент, который будет взять
// в качестве базового при вычилении абсолютных значений.
function unextendModel(model: Fields, segment: HTMLElement): Fields {
    const newModel = new Fields(model.document, null);

    for (const field of model.fields.values()) {
        const newField = unextendField(newModel, field, segment);
        newModel.fields.set(field.name, newField);
    }

    return newModel;
}

function compareCandidates(curCandidate: HTMLElement| null, newCandidate: HTMLElement): boolean {
    if (!curCandidate) {
        return true
    }

    // Здесь сказано следующее: если в поддереве элемента, на который кликнули, есть потенциальный сегмент,
    // относительно списочного элемента <li>, то такой сегмент в приоритете.
    // Это сделано потому, что в вёрстке чаще всего списочные, повторяющиеся блоки оформляют таким образом.
    // Вообще можно сделать более умную функцию, которая анализирует не только названия тегов, но и кол-во
    // блоков, которые сгенерирует обобщение. И брать большее, например.
    if(curCandidate.tagName.toLowerCase() != "li" && newCandidate.tagName.toLowerCase() == "li") {
        return true
    }

    return false;
}

function getNearExtendableSegment(model: Fields, elem: HTMLElement): HTMLElement | null {
    let curElement: HTMLElement | null = elem;

    let candidate = null;
    while (curElement) {
        const segmentInfo = Segment.fromElem(curElement);
        if (segmentInfo.children.size >= 1 && compareCandidates(candidate, curElement)) {
            const extended = extendModel(model, curElement);
            if (extended && extended.blockCount() > 1) {
                candidate = curElement;
            }
        }

        curElement = curElement.parentElement;
    }

    return candidate;
}

export default {
    getNearExtendableSegment,
    unextendModel,
    extendModel
}
